module.exports = __webpack_public_path__ + "media/images/ms-symbol-494de7c9.png";